import { render, staticRenderFns } from "./addKnowledges.vue?vue&type=template&id=398da8d3"
import script from "./addKnowledges.vue?vue&type=script&lang=js"
export * from "./addKnowledges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports